import { ComponentStyleConfig } from '@chakra-ui/react'

export const Link: ComponentStyleConfig = {
  baseStyle: {
    color: 'black',
    fontWeight: 'semibold',
  },
}
